export default "__VITE_ASSET__DUETVI9x__"